// extracted by mini-css-extract-plugin
export default {"loading":"Ct_agkMX-sSXyIh06VWBc"};